import { Flex } from "@chakra-ui/react";
import { useFormikContext } from "formik";
import React from "react";
import { Card } from "src/components/Layout/Card";
import { SegmentedControl } from "src/components/SegmentedControl";
import * as OrgConfig from "src/generated/hooks/org-config/requests";
import { LandingPage } from "src/scenes/public/Landing";
import { isNonEmptyString, isNullOrUndefined } from "src/services/predicates";
import * as RD from "src/types/remoteData";
import { FormikType, fromFormik } from "./Formik";

type Props = {
  accountLookup: OrgConfig.AccountLookupConfig | null;
};
export const Preview: React.FC<Props> = ({ accountLookup }) => {
  const [size, setSize] = React.useState<string>("desktop");
  const formik = useFormikContext<FormikType>();

  const image = formik.values.banner.image;
  const existingImageUrl = formik.values.banner.imageUrl;
  const [previewImageUrl, setPreviewImageUrl] = React.useState("");

  React.useEffect(() => {
    if (isNonEmptyString(existingImageUrl)) {
      setPreviewImageUrl(existingImageUrl);
      return;
    }

    if (isNullOrUndefined(image)) {
      setPreviewImageUrl("");
      return;
    }

    const objectUrl = URL.createObjectURL(image);
    setPreviewImageUrl(objectUrl);

    return () => {
      URL.revokeObjectURL(objectUrl);
    };
  }, [existingImageUrl, image]);

  const landingPage = React.useMemo(
    () => fromFormik(formik.values, previewImageUrl),
    [formik.values, previewImageUrl]
  );

  return (
    <Card
      showBorder
      flexGrow="1"
      padding="5"
      bg="gray.50"
      as={Flex}
      flexDirection="column"
      gap="4"
      position="sticky"
      top="0px"
    >
      <Flex alignSelf="center">
        <SegmentedControl
          radioProps={{ paddingX: "1rem" }}
          options={[
            {
              label: "Mobile",
              value: "mobile",
            },
            {
              label: "Deskop",
              value: "desktop",
            },
          ]}
          value={size}
          onChange={setSize}
        />
      </Flex>
      <Flex justifyContent="center" flexGrow="1">
        <Flex
          shadow="lg"
          width={size === "desktop" ? "100%" : "30rem"}
          height="70rem"
          overflow="auto"
        >
          <LandingPage
            accountLookup={RD.success(accountLookup)}
            landingPage={landingPage}
          />
        </Flex>
      </Flex>
    </Card>
  );
};
